import React, { useContext } from "react";
import SectionWhiteBoxItem from "../../../../../../components/SectionWhiteBoxItem/SectionWhiteBoxItem";
import { CampaignDetailType } from "../../../../configs/DeclareTypes";
import { useSelector } from "react-redux";
import { campaignDetailSelector } from "../../../../selectors/MarketingSelectors";
import { LocalizationContext } from "../../../../../../locales/Translation";

const VoucherCredit = () => {
  const { translations } = useContext(LocalizationContext);

  const campaignDetail: CampaignDetailType = useSelector(
    campaignDetailSelector
  );
  return (
    <>
      <div className={"section-white-box-column"}>
        <SectionWhiteBoxItem
          label={"Voucher type"}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          value={translations.voucherType[campaignDetail.voucher_reward.type]}
        />

        <SectionWhiteBoxItem
          label={"Voucher value"}
          value={`${campaignDetail.voucher_reward.currency} ${campaignDetail.voucher_reward.value}`}
        />
      </div>

      <div className={"section-white-box-column"}>
        <SectionWhiteBoxItem
          label={"Currency"}
          value={campaignDetail.voucher_reward.currency}
        />
      </div>
    </>
  );
};

export default VoucherCredit;
